import React, { useState,useContext } from "react";
import {
  Container,
  Row,
  Col,
  Table,
  Button,
  Form,
  Modal,
} from "react-bootstrap";
import { apiGet } from "../utils/apiFetch";
import apiPath from "../utils/apiPath";
import { isEmpty, pick } from "lodash";
import AuthContext from "../context/AuthContext";

const IpSearch = () => {
  const [currentItems, setCurrentItems] = useState([]);
    const [userExistData, setUserExistData] = useState([]);

  const [keyword, setKeyword] = useState("");
  let { user } = useContext(AuthContext);

  const LogData = async () => {
    const { status, data: response_users } = await apiGet(apiPath.searchIp, {
      keyword: keyword,
    });
    if (status === 200) {
      if (response_users.success) {
        setCurrentItems(response_users?.results?.data)
        setUserExistData(response_users?.results?.userExist)

      }
    }
  };
//  console.log("currentItems",currentItems);
  return (
    <div>
      <section className="main-inner-outer py-4">
        <Container fluid>
          <div className="db-sec">
            <h2 className="common-heading">IP Search</h2>
          </div>

          <div className="find-member-sec">
            <Form className="mb-4">
              <Form.Group className="position-relative mb-2">
                <Form.Control
                  type="text"
                  className="small_form_control"
                  placeholder="Enter User Name..."
                  value={keyword}
                  onChange={(e) => {
                    setKeyword(e.target.value);
                  }}
                />
                <i className="fas fa-search"></i>
              </Form.Group>
              <div className="d-flex flex-wrap block-search-sec">
                <Button
                  className="mb-2 mx-1 theme_light_btn"
                  onClick={() => LogData()}
                >
                  Search
                </Button>
              </div>
            </Form>

            <div className="inner-wrapper">
              <div className="common-container">
                <div className="account-table batting-table">
                  <div className="responsive">
                    <Table className="banking_detail_table">
                      <thead>
                        <tr>
                          {/* <th scope="col">Super Admin</th>
                          <th scope="col">Admin </th>
                          <th scope="col">Sub Admin</th>
                          <th scope="col">Senior Super</th>
                          <th scope="col">Super Agent</th>*/}
                          <th scope="col">Agent</th> 
                          <th scope="col">User</th>
                           <th scope="col">Matched</th> 
                        </tr>
                      </thead>
                      <tbody>
                        {currentItems &&
                          currentItems.map((item, key) => (
                            <tr key={key}>
                              
                              {/* <td>
                                {item?.userType === "super_admin"
                                  ? item?.username
                                  : item?.super_admin?.username
                                    ? item?.super_admin?.username
                                    : "-"}
                              </td>
                              <td>
                                {item?.userType === "admin"
                                  ? item?.username
                                  : item?.admin?.username
                                    ? item?.admin?.username
                                    : "-"}
                              </td>

                              <td>
                                {item?.userType === "sub_admin"
                                  ? item?.username
                                  : item?.sub_admin?.username
                                    ? item?.sub_admin?.username
                                    : "-"}
                              </td>
                              <td>
                                {item?.userType === "super_senior"
                                  ? item?.username
                                  : item?.super_senior?.username
                                    ? item?.super_senior?.username
                                    : "-"}
                              </td>

                              <td>
                                {item?.userType === "super_agent"
                                  ? item?.username
                                  : item?.super_agent?.username
                                    ? item?.super_agent?.username
                                    : "-"}
                              </td>*/}
                              <td>
                                {item?.userType === "agent"
                                  ? item?.username
                                  : item?.agent?.username
                                    ? item?.agent?.username
                                    : "-"}
                              </td> 
                              <td>
                                {item?.userType === "user"
                                  ? item?.username
                                  : "-"}
                                {/* {item?.pwd ? "- Pass(" + item?.pwd + ")" : ""} */}
                              </td>
                               <td>
                                {userExistData?.includes(item?.agent?._id) && "MATCHED"}
                              </td> 
                            </tr>
                          ))}
                        {isEmpty(currentItems) ? (
                          <tr>
                            <td colSpan={9}>No records found</td>
                          </tr>
                        ) : null}
                      </tbody>
                    </Table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Container>
      </section>
    </div>
  );
};

export default IpSearch;
